import React from "react";

export const buildNotificationUrl = (notification) => {
  if (!notification?.log_url) {
    return "";
  }

  const excludedLogTypes = [
    "sharelinks",
    "settings",
    "agents_activation",
    "clients_activation",
  ];

  if (excludedLogTypes.includes(notification.log_type)) {
    return "";
  }

  const accountno = notification.accountno || "";
  let url = `${notification.log_url}?accountno=${accountno}`;

  switch (notification.log_type) {
    case "agreements":
      url += `&agreement_accountno=${notification.agreement_accountno || ""}&log_type=${notification.log_type || ""}`;
      break;
    case "clients":
    case "agents":
      url += `&log_type=${notification.log_type || ""}`;
      break;
    case "credit_application":
      url += `&credit_app_id=${notification.credit_app_id || ""}&log_type=${notification.log_type || ""}`;
      break;
    case "rfq":
      url += `&rfq_accountno=${notification.rfq_accountno || ""}&log_type=${notification.log_type || ""}`;
      break;
    case "orders":
      url += `&orderno=${notification.orderno || ""}&log_type=${notification.log_type || ""}`;
      break;
    default:
      break;
  }

  return url;
};

const checkboxWrapperStyle = {
  display: "flex",
  justifyContent: "center",
  width: 24,
  flexShrink: 0,
};

export default function Notifications({
  notification,
  selectable = false,
  selected = false,
  onToggleSelect,
  compact = false,
}) {
  const isUnread = Number(notification?.is_read) === 0;
  const url = buildNotificationUrl(notification);

  const handleClick = () => {
    if (selectable && isUnread && onToggleSelect) {
      onToggleSelect(notification.id);
      return;
    }

    if (url) {
      window.location.href = url;
    }
  };

  const containerStyle = compact
    ? {
        padding: "14px 16px",
        border: selected ? "1px solid #818cf8" : "1px solid #e5e7eb",
        borderRadius: 14,
        display: "flex",
        alignItems: "center",
        gap: "12px",
        background: isUnread ? "#f8faff" : "#fbfcfe",
        boxShadow: selected
          ? "0 0 0 3px rgba(99, 102, 241, 0.12)"
          : "0 1px 2px rgba(15, 23, 42, 0.04)",
        cursor: url || (selectable && isUnread) ? "pointer" : "default",
        transition: "all 0.2s ease",
      }
    : {
        padding: "16px 18px",
        border: selected ? "1px solid #818cf8" : "1px solid #e5e7eb",
        borderRadius: 14,
        display: "flex",
        alignItems: "center",
        gap: "14px",
        background: isUnread ? "#f8faff" : "#fbfcfe",
        boxShadow: selected
          ? "0 0 0 3px rgba(99, 102, 241, 0.12)"
          : "0 1px 2px rgba(15, 23, 42, 0.04)",
        cursor: url || (selectable && isUnread) ? "pointer" : "default",
        transition: "all 0.2s ease",
      };

  return (
    <div
      className="nk-notification-item dropdown-inner"
      style={containerStyle}
      onClick={handleClick}
    >
      {selectable ? (
        <div className="custom-control custom-checkbox" style={checkboxWrapperStyle} onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            className="custom-control-input"
            id={`notif-select-${notification.id}`}
            checked={selected}
            disabled={!isUnread}
            onChange={() => onToggleSelect && onToggleSelect(notification.id)}
          />
          <label
            className="custom-control-label"
            htmlFor={`notif-select-${notification.id}`}
            style={{ cursor: isUnread ? "pointer" : "not-allowed" }}
          />
        </div>
      ) : null}

      <div className="nk-notification-icon">
        <div
          style={{
            width: compact ? 34 : 38,
            height: compact ? 34 : 38,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: isUnread ? "#eef2ff" : "#f3f4f6",
            color: isUnread ? "#4f46e5" : "#94a3b8",
            flexShrink: 0,
          }}
        >
          <em className={`icon ni ${isUnread ? "ni-bell-fill" : "ni-bell"}`}></em>
        </div>
      </div>

      <div
        className="nk-notification-content"
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: 6,
        }}
      >
        <div
          className="nk-notification-text"
          style={{
            fontWeight: isUnread ? 700 : 500,
            color: isUnread ? "#111827" : "#6b7280",
            fontSize: compact ? 14 : 15,
            lineHeight: 1.45,
            wordBreak: "break-word",
          }}
        >
          {notification.title}
        </div>

        {notification.description ? (
          <div
            style={{
              color: isUnread ? "#374151" : "#94a3b8",
              fontSize: compact ? 12 : 13,
              lineHeight: 1.5,
              wordBreak: "break-word",
            }}
          >
            {notification.description}
          </div>
        ) : null}

        <div
          className="nk-notification-time"
          style={{
            textAlign: "left",
            fontSize: compact ? 11 : 12,
            color: "#9ca3af",
            fontWeight: 500,
          }}
        >
          {notification.time}
        </div>
      </div>

      {!selectable && isUnread ? (
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: "#4f46e5",
            flexShrink: 0,
          }}
        />
      ) : null}
    </div>
  );
}
